export const CUSTOM_REPORTS_ERROR_MESSAGE_HEADER = 'Sorry, we had a problem loading your customers';
export const CUSTOM_REPORTS_NO_CUSTOMERS_HEADER = "You current don't have any customers";
export const CUSTOM_REPORTS_NO_CUSTOMERS_MESSAGE = 'Check back again later for customer reports';
